import React from 'react';
import { tokens } from '@fluentui/react-theme';
import { useNavigate } from 'react-router';

import { ReactComponent as LogoSVGSquare } from './actionable-agile-analytics_logo_square_no-tagline_colour.svg';
import { ReactComponent as LogoSVGSquareWhite } from './actionable-agile-analytics_logo_square_no-tagline_white.svg';
import { ReactComponent as ActionableAgileColorLogo } from './actionable-agile-analytics_logo_no-tagline_colour.svg';
import { ReactComponent as ActionableAgileWhiteLogo } from './actionable-agile-analytics_logo_no-tagline_white.svg';
import { LogoButton } from './styling';

type LogoDisplayProps = {
  isNormalScreenSize: boolean;
  scheme: 'Dark' | 'Light';
}

function LogoDisplay(
  {
    isNormalScreenSize,
    scheme,
  }: LogoDisplayProps) {
  const navigate = useNavigate();
  const isDarkMode = scheme === 'Dark';

  const onLogoClick = () => {
    navigate('/');
  };

  if (isNormalScreenSize) {
    if (isDarkMode) {
      return <LogoButton
        disableElevation
        disableRipple
        onClick={onLogoClick}
      >
        <ActionableAgileWhiteLogo
          aria-label="ActionableAgile by 55degrees"
          height={36}
          width={200}
          fill={tokens.colorNeutralForeground1}
        />
      </LogoButton>;
    }
    return <LogoButton
      disableElevation
      disableRipple
      onClick={onLogoClick}
    >
      <ActionableAgileColorLogo
        aria-label="ActionableAgile by 55degrees"
        height={36}
        width={200}
      />
    </LogoButton>;
  }

  if (isDarkMode) {
    return (
      <LogoButton
        disableElevation
        disableRipple
        onClick={onLogoClick}
      >
        <LogoSVGSquareWhite
          aria-label="ActionableAgile by 55degrees"
          height={36}
          width={36}
          fill={tokens.colorNeutralForeground1}
        />
      </LogoButton>
    );
  }
  return (
    <LogoButton
      disableElevation
      disableRipple
      onClick={onLogoClick}
    >
      <LogoSVGSquare
        aria-label="ActionableAgile by 55degrees"
        height={36}
        width={36}
      />
    </LogoButton>
  );
}

export default LogoDisplay;
